import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="documents--flow-timeline"
//
// Adds a brief visual flash to a timeline row before navigation so the
// click feels acknowledged. Pure UX polish — Turbo's anchor handling
// drives the actual navigation; the controller only intercepts the
// click long enough to apply the flash class, then releases.
export default class extends Controller {
  static targets = ["item"]
  static classes = ["flash"]
  static values = {
    flashDuration: { type: Number, default: 160 }
  }

  flashAndNavigate(event) {
    const link = event.currentTarget
    const href = link.getAttribute("href")

    // No href, or modifier-key click (open in new tab) — skip the flash
    // and let the browser/Turbo handle navigation natively.
    if (!href || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return
    }

    const item = link.closest(".flow-timeline__item")
    if (!item) return

    event.preventDefault()
    item.classList.add(this.hasFlashClass ? this.flashClass : "flow-timeline__item--flashing")

    window.setTimeout(() => {
      if (window.Turbo && typeof window.Turbo.visit === "function") {
        window.Turbo.visit(href)
      } else {
        window.location.assign(href)
      }
    }, this.flashDurationValue)
  }
}
